import { interpolateGreens, interpolateGreys, interpolateInferno, interpolateRdBu, interpolateRdYlGn, interpolateReds, interpolateTurbo, interpolateViridis } from "d3"

export enum ColorSpectrum {
    INFERNO = "inferno",
	VIRIDIS = "viridis",
	GRAYS = "grays",
    GREENS = "greens",
    REDS = "reds",
    RED_BLUE = "red_blue",
    RED_YELLOW_GREEN = "red_yellow_green",
    TURBO = "turbo",
    DISCRETE_RGB = "discrete_rgb"
}

export interface ColorSpectrumOption {
    label: string
    value: ColorSpectrum
}

export const COLOR_SPECTRUM_OPTIONS: ColorSpectrumOption[] = [
    { label: "Inferno", value: ColorSpectrum.INFERNO },
    { label: "Turbo", value: ColorSpectrum.TURBO },
    { label: "Viridis", value: ColorSpectrum.VIRIDIS },
    { label: "Grays", value: ColorSpectrum.GRAYS },
    { label: "Greens", value: ColorSpectrum.GREENS },
    { label: "Reds", value: ColorSpectrum.REDS },
    { label: "Red-Blue", value: ColorSpectrum.RED_BLUE },
    { label: "Red-Yellow-Green", value: ColorSpectrum.RED_YELLOW_GREEN },
    { label: "RGB (Discrete)", value: ColorSpectrum.DISCRETE_RGB },
]

// Heatmap dropdowns predate the Turbo and discrete RGB spectra and do not offer them.
export const HEATMAP_COLOR_SPECTRUM_OPTIONS: ColorSpectrumOption[] = COLOR_SPECTRUM_OPTIONS.filter(
    option => option.value !== ColorSpectrum.TURBO && option.value !== ColorSpectrum.DISCRETE_RGB
)

export const DISCRETE_RGB_COLORS = [
    "#000000",  // Black
    "#01007e",  // Deep blue
    "#003fff",  // Blue
    "#00bffe",  // Cyan
    "#01febe",  // Light cyan/turquoise
    "#00ff01",  // Green
    "#7efe00",  // Yellow-green
    "#ffff01",  // Yellow
    "#fe3f01",  // Orange
    "#ff013e",  // Red
    "#ff00bf",  // Magenta
    "#ff7fff"   // Light magenta/pink
]

export const interpolateDiscreteRGB = (t: number): string => {
    if (t > 1.0) return "#FFFFFF"
    if (t < 0.0) return "#000000"
    const index = Math.min(Math.floor(t * DISCRETE_RGB_COLORS.length), DISCRETE_RGB_COLORS.length - 1)
    return DISCRETE_RGB_COLORS[index]
}

export const getSpectrumInterpolator = (spectrum: ColorSpectrum) => {
	switch (spectrum) {
        case ColorSpectrum.INFERNO: return interpolateInferno
		case ColorSpectrum.VIRIDIS: return interpolateViridis
		case ColorSpectrum.GRAYS: return interpolateGreys
        case ColorSpectrum.GREENS: return interpolateGreens
        case ColorSpectrum.REDS: return interpolateReds
        case ColorSpectrum.RED_BLUE: return interpolateRdBu
        case ColorSpectrum.RED_YELLOW_GREEN: return interpolateRdYlGn
        case ColorSpectrum.TURBO: return interpolateTurbo
        case ColorSpectrum.DISCRETE_RGB: return interpolateDiscreteRGB

		default: return interpolateViridis
	}
}
